import { QueryClient } from "react-query";
import apiConfig from "../../configs/apiConfig";

const ReactQueryClient = new QueryClient(apiConfig.reactQueryConfig);

export default ReactQueryClient;
